export type TravelPriorityValue = -2 | -1 | 0 | 1 | 2;
export type ProfilePreferenceValue = -2 | -1 | 0 | 1 | 2;

export const TRAVEL_PRIORITY_IDS = ["lower-fares", "shorter-journeys", "fewer-stops"] as const;

export function travelPriorityPreferences(priority: TravelPriorityValue): Record<(typeof TRAVEL_PRIORITY_IDS)[number], ProfilePreferenceValue> {
  return {
    "lower-fares": priority < 0 ? Math.abs(priority) as ProfilePreferenceValue : 0,
    "shorter-journeys": priority > 0 ? priority : 0,
    "fewer-stops": priority > 0 ? priority : 0,
  };
}

export function travelPriorityFromPreferences(preferences: Record<string, ProfilePreferenceValue>): TravelPriorityValue {
  const savings = preferences["lower-fares"] || 0;
  const quicker = Math.max(preferences["shorter-journeys"] || 0, preferences["fewer-stops"] || 0);

  if (savings > quicker) return -savings as TravelPriorityValue;
  if (quicker > savings) return quicker as TravelPriorityValue;
  return 0;
}
